export default "__VITE_ASSET__DXMifgSr__"